import {
  showToastMessage,
  showLoading,
  hideLoading,
  showConfirm
} from '@/hooks/usePlugin'
import { getUrlParams } from '@/utils/params'
import { reportSGM } from '@jdt-jinke/jdpay_utils'

/** 接口响应 */
interface IRes {
  code?: string
  message?: string
  oriMesage?: string
  options?: Record<string, any>
  errorCode?: 'network' | 'abnormal' | ''
}
interface IDefaultParams {
  // 响应失败
  fail?: (data: any) => any
  // 接口出参
  res: IRes
  // 是否需要展示错误提示
  error?: boolean
  // sgm上报code
  sgmCode?: string
}

/** 方法入参 */
export interface IUseDataOptions {
  // 接口入参
  params?: object
  // 是否需要loading
  loading?: boolean
  // 是否需要展示错误提示
  error?: boolean
  // 业务响应成功
  success?: (data: any) => any
  // 响应失败
  fail?: (data: any) => any
}

/** 定义网关转化数据默认值 */
export const defaultOptions: IUseDataOptions = {
  // 接口入参
  params: {},
  // 是否需要loading
  loading: true,
  // 是否需要展示错误提示
  error: false,
  // 未登录的code
  success: () => {},
  // 响应失败
  fail: () => {}
}

function handleDefault({ fail, res, error }: IDefaultParams) {
  // res有值：业务失败回调，无值：表示网络或网关异常
  typeof fail === 'function' &&
    fail({
      ...res,
      errorCode: 'abnormal',
      message: res.message || '系统开小差了，请刷新后重试'
    })
  // 展示错误提示
  if (error) {
    showToastMessage(res?.message || res?.oriMesage || '服务异常，请稍后重试')
  }
  // 统一上报日志, SWF_TO_INNERCASHIER_URL 为拉起SDK收银台的错误码，是正常的
  if (!['SWF_TO_INNERCASHIER_URL'].includes(res.code || '')) {
    reportSGM({ code: 'useData_fail', type: 2, res })
  }
}

/** 通用数据处理接口 */
export async function useData(
  serviceAPI: (data: any) => any,
  options: IUseDataOptions
) {
  const { params, loading, error, success, fail } = {
    ...defaultOptions,
    ...options
  }

  // api校验
  if (typeof serviceAPI !== 'function') {
    console.log('API 异常')
    return
  }

  // 获取页面入参
  const query = getUrlParams() || {}

  // 展示loading
  loading && showLoading()

  console.log('query', query, params)
  // 存储接口异常信息
  let catchError: null | IRes = null

  // console.log('----usedata start-----:', catchError)
  // 接口调用
  const res =
    (await serviceAPI({ ...query, ...params }).catch((err: IRes) => {
      catchError = { ...err, errorCode: err.code || 'abnormal' }
    })) || {}

  // 关闭loading
  loading && hideLoading()

  console.log('useData result:', res, catchError)

  // 处理catch 异常
  if (catchError) {
    // 打印异常日志
    typeof fail === 'function' && fail(catchError)
    error && showToastMessage(catchError?.message || '服务异常，请稍后重试')
    // 上报埋点
    reportSGM({
      code: 'useData_catchError',
      type: 2,
      req: catchError?.options || {},
      err: catchError
    })
  } else if (res?.code) {
    console.log('膨胀金系统相关接口：', res, catchError)
    switch (res.code) {
      // 业务错误码返回成功
      case '000000':
        return typeof success === 'function' && success(res.data)
      // 停机迁移
      case 'SHUT_DOWN':
        showConfirm({
          title: '无法操作',
          messageAlign: 'left',
          content:
            res?.message ||
            '今日1：00-5：00系统升级，期间交易暂停受理，请在升级完成后重试，给您带来不便请您谅解。',
          okBtnTxt: '我知道了',
          okCbFun: () => {
            reportSGM({
              code: serviceAPI.name + '_stopToMoveConfirm',
              type: 3,
              res
            })
          }
        })
        return
      case 'SWF_RISK_CANNOT_BUY_A':
        reportSGM({ code: serviceAPI.name + '_risk_scalper', res, type: 3 })
        handleDefault({ fail, res, error })
        break
      case 'SWF_RISK_CANNOT_BUY_B':
        reportSGM({ code: serviceAPI.name + '_risk_launder', res, type: 3 })
        handleDefault({ fail, res, error })
        break
      default:
        handleDefault({ fail, res, error })
    }
  } else if (typeof res?.resultCode === 'number') {
    console.log('会员码系统相关接口：', res, catchError)
    const { resultCode, resultData, resultMsg } = res
    switch (res.resultCode) {
      case 0:
        console.log('会员码接口响应正常：', resultData)
        typeof success === 'function' && success(resultData)
        break
      default:
        handleDefault({
          fail,
          res: { code: resultCode, message: resultMsg },
          error
        })
    }
  } else {
    // 没有 code 码的情况，需要走默认兜底
    handleDefault({ fail, res, error })
  }
}
